import type {
    TAllRowsAvailable,
    TRowReviewWithOperatingStatements,
} from "./typesGrids";

export const capitalize = (s: string, all: boolean = false) => {
    return all
        ? s
              .split(" ")
              .map(s => s.charAt(0).toUpperCase() + s.slice(1))
              .join(" ")
        : s.charAt(0).toUpperCase() + s.slice(1);
};

const emptyCellValue = "";
const errorCellValue = "";

export const formatNumber = (value: number | null): string => {
    const isCellEmpty = value === null;
    if (isCellEmpty) return emptyCellValue;

    const isValueAProperNumber = !isNaN(value) && isFinite(value);
    if (!isValueAProperNumber) return errorCellValue;

    if (value === 0) return "0.00";
    return (value / 100).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export const getPinnedRowBackgroundColor = (
    row:
        | TAllRowsAvailable
        | TRowReviewWithOperatingStatements
        | null
        | undefined,
) => {
    if (!row) return null;
    if ("pinnedRowColor" in row) {
        if (row.pinnedRowColor === "green") return "var(--proda-green-20)";
        if (row.pinnedRowColor === "blue") return "var(--proda-light-blue)";
        if (row.pinnedRowColor === "red") return "var(--proda-red-20)";
    }
    if (row.rowId === "row-altered" || row.rowId === "row-original") {
        return "var(--proda-light-blue)";
    }
    return null;
};
